import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { createTaskFeed, deleteTaskFeed, getTaskFeed } from '../api/taskFeed';

/**
 * The signed-in person's task calendar feed. Keyed by user: impersonation
 * switches the person without a reload, and one person's status must not
 * stand in for another's.
 */
export function useTaskFeed(userId: string) {
  return useQuery({ queryKey: ['task-feed', userId], queryFn: getTaskFeed });
}

export function useCreateTaskFeed(userId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createTaskFeed,
    onSuccess: (link) => {
      const { enabled, createdAt, lastFetchedAt } = link;
      queryClient.setQueryData(['task-feed', userId], { enabled, createdAt, lastFetchedAt });
    },
  });
}

export function useDeleteTaskFeed(userId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteTaskFeed,
    onSuccess: () =>
      queryClient.setQueryData(['task-feed', userId], {
        enabled: false,
        createdAt: null,
        lastFetchedAt: null,
      }),
  });
}
